<div class="modal-header d-flex justify-content-end">
    <button type="button" class="close" aria-label="Close" (click)="fecharModal()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div *ngIf ="Orcamento.Agencia != null" id="contentSlipPrint">

    <div class="modal-body">

      <h4 style="padding-left:17px;" class="modal-title" id="modal-basic-title">
        {{Orcamento.Agencia.NomeFantasia}}<br /><small>{{'SLIP DE CAIXA -' | translate}} {{ Orcamento.Id}}</small>
                 <button (click)="printSlip('contentSlipPrint')" class="btn btn-primary" style="float:inline-end">Imprimir</button>
      </h4>

      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <p><b>Agente:</b> {{Orcamento.Agencia.RazaoSocial}}</p>
            <p *ngIf="Orcamento.LocalizadorAereo" style="padding-bottom:0px;margin-bottom:0px;"> <b>{{"Localizador: " | translate}}</b>
              {{Orcamento.Aereos[0]?.LocalizadorAereo}}</p>
          </div>
          <div class="col-md-4">
            <p><b>{{'Data:' | translate}}</b> {{Orcamento.Agencia.Alteracoes.CriadoEm | date :'dd/MM/yyyy'}}</p>
            <p style="padding-bottom:0px;margin-bottom:0px;"><b>{{"Consultor: " | translate}}:</b> {{Orcamento.Agente.Nome}}</p>
          </div>
          <div class="col-md-4">
            <p><b>{{'E-Mail:' | translate}}</b> {{Orcamento.Agente.Email}}</p>
            <p style="padding-bottom:0px;margin-bottom:0px;"><b>{{'Telefone:' | translate}}</b> {{Orcamento.Agente.Telefone}}</p>
          </div>
        </div>
      </div>

      <div class="card-body table-full-width table-responsive">
        <table *ngIf="pagamentosAprovados"  style='font-family: calibri; width: 100%'  class="table table-hover table-striped">
          <thead>
            <tr style="background-color:#fbfbfb;">
              <th colspan="9">{{'PAGAMENTO(S)' | translate}}</th>
            </tr>
            <tr>
              <th>{{"TIPO" | translate}}</th>
              <th>{{'CRIADO' | translate}}</th>
              <th>{{"PAX" | translate}}</th>
              <th>{{'PARCELAS' | translate}}</th>
              <th>{{"VALOR" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let j of pagamentosAprovados">
              <td>{{ j.TipoDesc}} {{ j.CondicaoPagamento.Descricao | translate}}</td>
              <td>{{ j.Alteracoes.CriadoPor}}</td>
              <td>{{ j.PaxPagante.Nome}}</td>
              <td>{{ j.CondicaoPagamento.Parcelas}}</td>
              <td>R$ {{ j.Valor}}</td>
            </tr>
          </tbody>
        </table>

        <table *ngIf="Orcamento.Pessoas[0] != null || Orcamento.Pessoas[0] != ''" style='font-family: calibri; width: 100%'
          class="table table-hover table-striped">
          <thead>
            <tr style="background-color: #fbfbfb;" style="background-color: #fbfbfb;">
              <th colspan="9">{{'PASSAGEIRO(S)' | translate}}</th>
            </tr>
            <th>{{"TIPO" | translate}}</th>
            <th>{{'NOME' | translate}}</th>
            <th>{{'SOBRENOME' | translate}}</th>
            <th>{{"SEXO" | translate}}</th>
            <th>{{"NASCIMENTO" | translate}}</th>
          </thead>
          <tbody>
            <tr *ngFor="let pessoa of Orcamento.Pessoas">
              <td> {{pessoa.TipoDesc}} </td>
              <td> {{pessoa.Nome}}</td>
              <td> {{pessoa.Sobrenome}} </td>
              <td> {{pessoa.Sexo}}</td>
              <td> {{pessoa.Nascimento | date :'dd/MM/yyyy'}}</td>
            </tr>
          </tbody>
        </table>

        <div style="padding-top:15px;" *ngIf="Orcamento.Aereos[0]?.Seguimentos">
          <div class="row">

            <div class="col-md-2 text-left text-xs-left" style="text-align: left;">
              <hr/>
          <span><b>{{"TRECHO(S)" | translate}}</b></span>
            </div>
            <div class="col-md-6">
              <div   *ngFor="let ht of Orcamento.Aereos[0].Seguimentos[0].Voos">
                <div class="row">
                  <div style="padding-bottom: 9px;" class="col-md-4">
                    <span style="background-color: #f9f9f9;padding:3px;"><b>{{ht.AeroportoPartida}}</b></span>  ->
                    <span style="background-color: #f9f9f9;padding:3px;"><b>{{ht.AeroportoChegada}}</b></span>  ->
                  </div>
                  <div class="col-md-4">
                    <span style="background-color: #f9f9f9;padding:3px;"><b>{{ht.DataPartida | date :'dd/MM/yyyy'}}</b> </span>
                    <span *ngIf="date != null" style="background-color: #f9f9f9;padding:3px;">
                      <b>{{ht.DataChegada | date :'dd/MM/yyyy'}}</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 15px;"></div>

        <table *ngIf="Orcamento.LocalizadorAereo" style="width:100%;background-color:#fbfbfb;"
          class="table table-hover table-striped" style='font-family: calibri; width: 100%; '>
          <thead>
            <tr style="background-color: #fbfbfb;">
            <th colspan="9">TARIFA(S)</th>
            </tr>
            <th>{{"TIPO" | translate}}</th>
            <th>{{'QTD' | translate}}</th>
            <th>TR. NET</th>
            <th>TR. VENDA</th>
            <th>MARKUP</th>
            <th>{{'TAXAS' | translate}}</th>
            <th>Tx Serv.</th>
            <th>{{'TOTAL VENDA' | translate}}</th>
          </thead>
          <tbody>
            <tr *ngFor="let aereo of Orcamento.Aereos">
              <td> {{ aereo.PaxesTarifa[0].TipoPaxDesc }} </td>
              <td> {{ aereo.PaxesTarifa[0].QtdPax }} </td>
              <td> BRL {{ aereo.PaxesTarifa[0].ValorTarifaNet }}</td>
              <td> BRL {{ aereo.PaxesTarifa[0].ValorTarifa }}</td>

              <td> BRL {{ aereo.PaxesTarifa[0].ValorTaxa }}</td>
              <td> BRL {{ aereo.PaxesTarifa[0].ValorTaxaServico }}</td>
              <td> BRL {{ aereo.PaxesTarifa[0].ValorTarifa + aereo.PaxesTarifa[0].ValorTaxa +
                aereo.PaxesTarifa[0].ValorTaxaServico | number : '1.2-2'}}</td>
            </tr>
          </tbody>

        </table>

        <div class="row text-center" style="padding-bottom: 25px;"></div>

        <div *ngIf="Orcamento.HoteisPorOpcao">
          <div *ngFor="let opcao of Orcamento.HoteisPorOpcao">

            <b>{{ 'OPÇÃO' | translate }} {{opcao.Opcao}}</b>

            <div style="padding-top:7px;" *ngFor="let hotel of opcao.Hoteis; let i = index">

              <div class="row">
                <div class="col-md-12">
                  <b>Hotel: {{hotel.Nome }}
                    {{ hotel.Estrelas }} Estrelas</b>
                </div>
                <div class="col-md-12">
                  <b> {{'Cidade:' | translate}} {{ hotel.Cidade.Nome }} </b>
                </div>
                 <div class="col-md-12">
                  <b> {{'Fornecedor:' | translate}} {{ hotel.Fornecedor }} </b>
                </div>
                <div class="col-md-12">
                  <b>{{'Check-in:' | translate}} {{ hotel.Checkin | date:'dd/MM/yyyy' }}  {{'Check-out:' | translate}}{{ hotel.Checkout| date:'dd/MM/yyyy' }} </b>
                </div>
              </div>

              <div class="row" style="padding-bottom: 15px;"></div>

              <table class="table mb-5 table-hover table-striped" style='font-family: calibri; width: 100%'>
                <thead>
                  <tr>
                    <th>{{'Qtde' | translate}}</th>
                    <th>{{'Regime' | translate}}</th>
                    <th>{{'Apartamento' | translate}}</th>
                    <th>{{'Pessoas' | translate}}</th>
                    <th>{{'Markup' | translate}}</th>
                    <th>{{'Valor Net' | translate}}</th>
                    <th>{{'Câmbio' | translate}}</th>
                    <th *ngIf="hotel.Fornecedor == 'F'">{{"SubFornecedor" | translate}}</th>
                    <th *ngIf="hotel.PossuiQuartoComIRRF">IRRF</th>
                    <th>{{'V. Total' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let quarto of hotel.Quartos">
                    <td>{{quarto.Quantidade}}</td>
                    <td>{{quarto.DescricaoPensao}}</td>
                    <td>{{quarto.Descricao}}</td>
                    <td>{{quarto.Adultos}} Adulto(s)<br>{{quarto.Criancas}} {{'Criança' | translate}}(s)</td>
                    <td>{{quarto?.Markup?.MarkupDireto}}</td>
                    <td>{{quarto.MoedaNet.Sigla}}&nbsp;{{quarto.ValorNet}}</td>
                    <td>{{quarto.Taxa}}</td>
                    <td *ngIf="hotel.Fornecedor == 'F'">{{quarto.SubFornecedor}}</td>
                    <td style="color:red !important" *ngIf="quarto.ValorIRRFFechamento && quarto.ValorIRRFFechamento > 0">
                      {{quarto.MoedaFechamento.Sigla}}&nbsp;{{quarto.ValorIRRFFechamento | currency :'BRL':'':'2.2-2'}}
                    </td>
                    <td>{{quarto.MoedaNet.Sigla}}&nbsp;{{quarto.ValorVenda}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="Orcamento.Servicos">
          <div *ngFor="let servico of Orcamento.Servicos">
            <h6 class=""><strong>{{"SERVIÇO" | translate}} - {{servico.Titulo}}</strong>
              <span
                *ngIf="servico?.ExtraIntegracao2?.CategoriaServico">({{servico?.ExtraIntegracao2?.CategoriaServico}})</span>
              <span>({{servico.Fornecedor}})</span>
            </h6>
            <div class="row">
              <div class="col-md-3">
                <p><strong>{{'Data Inclusão' | translate}}: </strong> {{servico.Alteracoes.CriadoEm | date :'dd/MM/yyyy'}}
                </p>
                <p *ngIf="servico.DataReserva"><strong>{{'Data da Reserva:' | translate}}</strong> {{servico.DataReserva |
                  date :'dd/MM/yyyy HH:mm:ss'}}
                </p>
              </div>
              <div class="col-md-3">
                <p><strong>{{'Cidade' | translate}}:</strong> {{servico.Cidade?.Nome}}</p>
                <span
                  *ngIf="servico.Ate && (servico.Status == 3 || servico.Status == 4 || servico.Status == 1)"><strong>
                    {{'Data do Serviço' | translate}}:
                  </strong> {{servico.Ate | date :'dd/MM/yyyy'}}</span>
              </div>
              <div class="col-md-3">
                <p style="display:none;" *ngIf="servico?.ExtraIntegracao2?.NomeFornecedor"><strong>{{'Fornecedor' |
                    translate}}:</strong> {{servico?.ExtraIntegracao2?.NomeFornecedor}}</p>
                <p *ngIf="servico.Status != 0"><strong>REF:</strong> {{servico.Agrupador}} / {{servico.Localizador}}</p>
              </div>
              <div class="col-md-12">
                <table class="table mb-5 table-hover table-striped" style='font-family: calibri; width: 100%'>
                  <thead>
                    <tr>
                      <th>{{'Localizador' | translate}}</th>
                      <th>{{'Fornecedor' | translate}}</th>
                      <th>{{'Pessoas' | translate}}</th>
                      <th>{{'Markup' | translate}}</th>
                      <th>{{'V. Net' | translate}}</th>
                      <th>{{'Venda' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{servico.Localizador}}</td>
                      <td>{{servico.Fornecedor}}</td>
                      <td>{{servico.Adt}} Adulto(s)<br>{{servico.Chd}} {{'Criança' | translate}}(s)</td>
                      <td>{{servico.Markup?.MarkupDireto}}</td>
                      <td>{{servico.ValorNet | currency:'BRL':true:'2.2-2'}}</td>
                      <td>{{servico.ValorVenda | currency:'BRL':true:'2.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="Orcamento.OfflineProdutos">
          <div *ngFor="let servico of Orcamento.OfflineProdutos">

            <div class="row">
              <div class="col-md-3">
                <h6 class=""><strong>{{"PRODUTO OFF-LINE" | translate }} - {{servico.Titulo}} </strong> </h6>
                <span style="padding-top:7px;">{{servico.OfflineProdutoTipo.Descricao}}</span>

              </div>
              <div class="col-md-3">
                <span>{{servico.Fornecedor}}</span>
              </div>
              <div class="col-md-3">
                <p><strong>{{'Data Inclusão' | translate}}: </strong> {{servico.Alteracoes.CriadoEm | date :'dd/MM/yyyy'}}
                </p>

                <p *ngIf="servico.Alteracoes.AlteradoEm"><strong>{{'Data da Modificação:' | translate}}</strong>
                  {{servico.Alteracoes.AlteradoEm | date :'dd/MM/yyyy HH:mm:ss'}}
                </p>

              </div>

              <div class="col-md-12">
                <span class="row" style="padding-top:15px;">
                </span>
                <table class="table mb-5 table-hover table-striped" style='font-family: calibri; width: 100%;'>
                  <thead>
                    <tr>
                      <th>{{"Qtd" | translate}}</th>
                      <th colspan="2">{{"Descrição" | translate}}</th>
                      <th>Sub Total</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{servico.QtdAdt}}</td>
                      <td [innerHTML]="servico.Descritivo">{{ servico.Descritivo }}</td>
                      <td>
                      </td>
                      <td>{{servico.ValorTotal | currency:'BRL':true:'2.2-2'}}</td>
                      <td>{{servico.ValorTotalFechamento | currency:'BRL':true:'2.2-2'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer">
    <!-- <button type="button" id="btnImprimir" class="btn btn-success btn-sm" printSectionId="contentSlipPrint" ngxPrint
      printTitle="Orcamento-{{Orcamento.Id}}" [useExistingCss]="true">{{'Imprimir' | translate}}</button> -->
  </div>
